import React from 'react'
import { Button } from '@mui/material'
import firebase from "firebase/compat/app"
import { auth } from '../../firebase';
import googleLogo from '../../images/googleLogo.png'

const SignIn = () => {
    function signInWithGoogle(){
        const provider = new firebase.auth.GoogleAuthProvider();
        auth.signInWithPopup(provider);
    }
  return (
    <div className='signIn'>
      <div className='sigInBox'>
        <h1>Twitter clone</h1>
        <h3>サインイン</h3>
        <div className='signInContainer'>
          <img src={googleLogo} className='googleLogo' />
          <Button onClick={signInWithGoogle} className='signInbutton'>
            <span>Google</span>でログイン
          </Button>
        </div>
      </div>
    </div>
  )
}

export default SignIn